const CompromisoAddInterfacePublicRegister = {
  token: '',

  account: {
    // Username: '', // Se añade al final (copiando el cellphone)
    Password: '',
    Confirm: '',
    PIN: '',
  },
  user: {
    Nombre: '',
    Paterno: '',
    Materno: '',
    FechaNacimiento: '',
    idSexo: '',
    idEstadoNacimiento: '',

    INE: '',
    VigenciaINE: '',
    SeccionVota: '',
  },
  contact: {
    Celular: '',
    Telefono: '',
    TelMensajes: '',
    Correo: '',
  },
  address: {
    TipoVialidad: 'C', // al final se une con CalleVive
    CalleVive: '',
    NumExtVive: '',
    NumIntVive: '',
    idEntidadVive: 11,
    idMunicipioVive: '',
    idLocalidadVive: '',
    ColoniaVive: '',
    CPVive: '',
  },
  social: {
    facebook: '',
    instagram: '',
    tiktok: '',
    x: '',
  },
  academy: {
    idGrade: '',
    generalEducation: '',
  },
  extras: {
    idPartido: 1,
    idUsuarioPropietario: 1,
    idEstructuraSocial: 1,
    medioConfirmacion: 'sms',
    // EsVoluntario: 0,
    // idVoluntario: null,
    // TieneAuto: 0,
    // TieneExperiencia: 0,
    // AceptaCuidarOtra: 0,
  },
  /* volunteer: {
    EsVoluntario: null,
    idVoluntario: null,
    idDeseaParticipar: null,
    // TieneAuto: 0,
    // TieneExperiencia: 0,
    // AceptaCuidarOtra: 0,
  }, */
};

export { CompromisoAddInterfacePublicRegister };
